import { useEffect } from 'react';
import { db } from '../firebase';
import { onSnapshot, collection } from 'firebase/firestore';
import useProductStore from '../stores/productStore';

const useProductListener = () => {
    const { setProducts, setIsLoading } = useProductStore();

    useEffect(() => {
        const productsRef = collection(db, 'products');

        const unsubscribe = onSnapshot(productsRef, (snapshot) => {
            if (!snapshot.empty) {
                const products = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setProducts(products);
            } else {
                setProducts([]);
            }
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [setIsLoading, setProducts]);
};

export default useProductListener;
